import api from './api';

export const fetchChildren = async (user_id) => {
    try {
        const response = await api.get(`/child-list?user_id=${user_id}`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;  // Rethrow the error to be handled in the component
    }
};

export const fetchChildSchedule = async (child_id) => {
    try {
        // const response = await api.get(`/student-routine-default/${child_id}`)
        const response = await api.get(`/get-schedule/${child_id}`)
        
        return response.data.data
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;  // Rethrow the error to be handled in the component
    }
};

export const fetchAttendanceMonth = async (child_id) => {
    try {
        const today = new Date();
        const thisMonth = today.getMonth() + 1;
        const thisYear = today.getFullYear();
        
        const response = await api.get(`/attendance/month-report?month=${thisMonth}&year=${thisYear}&student_id=${child_id}`)
        
        return response.data.data
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;  // Rethrow the error to be handled in the component
    }
};

export const fetchAttendanceDay = async (child_id, fulldate) => {
    try {
        const response = await api.get(`/attendance/day-report?student_id=${child_id}&date=${fulldate}`)
        
        return response.data.data
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;  // Rethrow the error to be handled in the component
    }
};

export const fetchChildHistory = async (child_id) => {
    try {
        const response = await api.get(`/wallet/student/${child_id}`)
        
        return response.data.data
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;  // Rethrow the error to be handled in the component
    }
};

export const fetchChildExtracurricular = async(student_id) => {
    try {
        const response = await api.get(`/student-group/get/${student_id}`)

        return response.data.data
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error
    }
}

export const fetchAllExtracurricular = async () => {
    try {
        const response = await api.get(`/student-group/get-all`)
        
        return response.data
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error
    }
};

export const fetchCurrentTopics = async (data) => {
    try {
        const response = await api.get(`/get-topics/${data.studentId}?tanggal=${data.fullDate}&subject_id=${data.subjectId}`)
        
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error
    }
};

export const createStudentLeaves = async (data) => {
    try {
        const response = await api.post('/izin/create', data)

        return response;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error
    }
}

export const fetchStudentLeaves = async (student_id) => {
    try {
        const response = await api.get(`/izin/get/${student_id}`)
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error
    }
}

export const fetchBehaviourRecords = async (student_id) => {
    try {
        const response = await api.get(`/behaviour-records/${student_id}`)
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error
    }
}

export const fetchCounselingAttendance = async (student_id) => {
    try {
        const response = await api.get(`/attendance/counseling/${student_id}`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchFeesPayment = async (student_id) => {
    try {
        const response = await api.get(`/fees/get-payments/${student_id}`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const feesPaymentTransaction = async (fees_id, data) => {
    try {
        const response = await api.post(`/fees/transaction/${fees_id}`, data);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const homeworkList = async (student_id) => {
    try {
        const response = await api.get(`/homework/${student_id}`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching homework:', error);
        throw error;
    }
};

export const uploadHomework = async (student_id, data) => {
    try {
        const response = await api.post(`/homework/upload/${student_id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        return response.data.data;
    } catch (error) {
        console.error('Error upload homework:', error);
        throw error;
    }
};

export const setWalletLimit = async (user_id, data) => {
    try {
        const response = await api.post(`/wallet/set-wallet-limit/${user_id}`, {walletLimit: data});
        
        return response.data.data;
    } catch (error) {
        console.error('Error set wallet limit:', error);
        throw error;
    }
}

export const fetchBills = async (user_id) => {
    try {
        const response = await api.get(`/bills/${user_id}`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching bills:', error);
        throw error;
    }
}

export const billPayment = async (user_id, bill_id, amount) => {
    try {
        const response = await api.post(`/bills/pay/${user_id}`, {
            "bill_invoice_id": bill_id,
            "amount": amount
        });
        
        return response.data.data;
    } catch (error) {
        console.error('Error pay bill:', error);
        throw error;
    }
}

export const billPaymentVA = async (user_id, bill_invoice_id, amount) => {
    try {
        const response = await api.post(`/bills/invoice/va/${user_id}`, {
            "bill_invoice_id": bill_invoice_id,
            "amount": amount,
        });
        
        return response.data;
    } catch (error) {
        console.error('Error pay bill:', error);
        throw error;
    }
}

export const billPaymentBSI = async (user_id, bill_invoice_id, amount) => {
    try {
        const response = await api.post(`/bills/invoice/bsi/${user_id}`, {
            "bill_invoice_id": bill_invoice_id,
            "amount": amount,
        });
        return response.data;
    } catch (error) {
        console.error('Error pay bill:', error);
        throw error;
    }
}

export const billPaymentStatus = async (bill_id) => {
    try {
        const response = await api.get(`/bill-invoice/payment-status/${bill_id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching bill payment status:', error);
        throw error;
    }
}

export const createCombinedInvoice = async (user_id, bill_ids, is_native) => {
    try {
        
        const response = await api.post(`/bills/bulk-payment`, {
            "user_id": user_id,
            "ids": bill_ids,
            "is_native": is_native
        });
        
        return response.data;
    } catch (error) {
        console.error('Error pay bill:', error);
        throw error;
    }
}

export const fetchSubjectAttendance = async (student_id) => {
    try {
        const response = await api.get(`/attendance/subject/${student_id}`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching subject attendance:', error);
        throw error;
    }
}

export const eraportSettings = async (student_id, academic_id, semester_id) => {
    try {
        const response = await api.get(`/eraport/settings`, {
            params: {
                student_id: student_id,
                academic_id: academic_id,
                semester_id: semester_id
            }
        });
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching eraport settings:', error);
        throw error;
    }
}

export const academicYears = async () => {
    try {
        const response = await api.get(`/academic-years`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching academic years:', error);
        throw error;
    }
}

export const submitParentResponse = async (student_id, academic_id, semester_id, response) => {
    try {
        const data = {
            student_id,
            academic_id,
            semester_id,
            response
        };
        const result = await api.post(`/eraport/submit-parent-response`, data);
        return result.data;
    } catch (error) {
        console.error('Error submitting parent response:', error);
        throw error;
    }
};

export const eraportSubjectScore = async (student_id, academic_id, semester_id, score_type) => {
    try {
        const response = await api.get(`/eraport/subject-score`, {
            params: {
                student_id: student_id,
                academic_id: academic_id,
                semester_id: semester_id,
                score_type: score_type
            }
        });
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching eraport subject score:', error);
        throw error;
    }
}

export const studentLearningReport = async (student_id, academic_id, semester_id) => {
    try {
        const response = await api.get(`/student-learning-report`, {
            params: {
                student_id: student_id,
                academic_id: academic_id,
                semester_id: semester_id
            }
        });
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching eraport learning report:', error);
        throw error;
    }
}

export const quranJuz = async(student_id) => {
    try {
        const response = await api.get(`/quran-juz/${student_id}`);
                
        return response.data.data;
    } catch (error) {
        console.error('Error fetching eraport learning report:', error);
        throw error;
    }
}

export const tahfidz = async(student_id, juz_id) => {
    try {
        const response = await api.get(`/student-tahfidz/${student_id}/${juz_id}`);
                
        return response.data.data;
    } catch (error) {
        console.error('Error fetching eraport learning report:', error);
        throw error;
    }
}

export const events = async (year, month, student_id) => {
    try {
        const response = await api.get(`/academic-calendar/get-month-events`, {
            params: {
                year: year,
                month: month,
                student_id: student_id
            }
        });
        
        return response.data;
    } catch (error) {
        console.error('Error fetching events:', error);
        throw error;
    }
}